import { styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC, ReactNode } from 'react';

import { FormattedMessage } from './FormattedMessage';

interface DialogContentProps {
  actions: ReactNode;
}

const Content = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  padding: theme.spacing(6, 3),
  background: theme.palette.background.paper,
}));

const Text = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(6, 0),
}));

const Actions = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
});

export const DialogContent: FC<DialogContentProps> = ({ actions }) => {
  const { getTestId } = useTestId();

  return (
    <Content data-testid={getTestId('content')}>
      <Typography
        variant="h4"
        align="center"
        color="textSecondary"
      >
        <FormattedMessage id="congratulations" />
      </Typography>
      <Text
        variant="body1"
        align="center"
      >
        <FormattedMessage id="youHaveLoyaltyPointsThatYouCanUseOnThisProduct" />
        <br />
        <FormattedMessage id="chooseHowYouWantToPayForIt" />
      </Text>
      {Boolean(actions) && <Actions data-testid={getTestId('actions')}>{actions}</Actions>}
    </Content>
  );
};

export default DialogContent;
